import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=37b4bac6"
import script from "./DynamicForm.vue?vue&type=script&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&lang=ts"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=37b4bac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports